/* unplugin-vue-components disabled */import script from "./PostBoxRowNormal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostBoxRowNormal.vue?vue&type=script&setup=true&lang=ts"

import "./PostBoxRowNormal.vue?vue&type=style&index=0&id=799b190a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799b190a"]])

export default __exports__